var map = {
	"./10.png": "f6QZ",
	"./11.png": "mTd6",
	"./12.png": "8N5E",
	"./13.png": "I9NY",
	"./14.png": "4R21",
	"./15.png": "j8xc",
	"./20.png": "ba57",
	"./21.png": "hXgP",
	"./22.png": "SRTt",
	"./23.png": "Xps3",
	"./24.png": "7AH1",
	"./25.png": "2mlK",
	"./30.png": "KPnd",
	"./31.png": "++Nv",
	"./32.png": "a7nj",
	"./33.png": "fo2O",
	"./34.png": "bTPj",
	"./35.png": "VSS5",
	"./36.png": "v4Bi",
	"./37.png": "aC4b",
	"./38.png": "RC7x",
	"./40.png": "RY6E",
	"./41.png": "gqSF",
	"./42.png": "gGWM",
	"./43.png": "b6lB",
	"./44.png": "5ZMu",
	"./45.png": "pwWV",
	"./50.png": "MGU5",
	"./51.png": "6Q/v",
	"./52.png": "Zo2h",
	"./53.png": "dLxo",
	"./54.png": "qcl1",
	"./60.png": "mOaQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YfKw";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon ^\.\/.*\.png$
// module id = YfKw
// module chunks = 1